import { render, staticRenderFns } from "./overview-saved-assessments.vue?vue&type=template&id=1a364455&scoped=true"
import script from "./overview-saved-assessments.vue?vue&type=script&lang=js"
export * from "./overview-saved-assessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a364455",
  null
  
)

export default component.exports